import { render, staticRenderFns } from "./VideosManager.vue?vue&type=template&id=432f0c97"
import script from "./VideosManager.vue?vue&type=script&lang=js"
export * from "./VideosManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports